var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreathalyzer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 121,
    viewBox: "0 0 83 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.383789 5.37778C0.383789 8.45079 2.177 11.1397 3.0736 11.9079L4.22638 11.5238H23.0551L25.3606 10.3714L76.4671 11.1397H81.0782C81.5906 10.6275 82.6153 8.98857 82.6153 6.53016C82.6153 4.07175 81.3344 2.4328 81.0782 1.92063H25.3606L23.4393 0.384127H3.84212L3.0736 0C2.177 0.512169 0.383789 2.30476 0.383789 5.37778Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87963 6.14618C4.87963 7.68105 4.58817 9.04622 4.13874 10.009C3.67038 11.0122 3.12303 11.4081 2.68981 11.4081C2.2566 11.4081 1.70925 11.0122 1.24089 10.009C0.791458 9.04622 0.5 7.68105 0.5 6.14618C0.5 4.61131 0.791458 3.24614 1.24089 2.2834C1.70925 1.28012 2.2566 0.884277 2.68981 0.884277C3.12303 0.884277 3.67038 1.28012 4.13874 2.2834C4.58817 3.24614 4.87963 4.61131 4.87963 6.14618Z",
    stroke: "url(#paint0_linear_3707_108411)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0556 0.768066C21.7822 0.768066 20.75 3.34776 20.75 6.52997C20.75 7.45319 20.8369 8.3257 20.9913 9.09921",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8242 6.53008C23.8242 4.19646 24.5124 2.30469 25.3613 2.30469",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4998 6.52993C82.4998 7.742 82.253 8.81461 81.8773 9.56569C81.4867 10.3466 81.0396 10.6395 80.6942 10.6395C80.3489 10.6395 79.9017 10.3466 79.5111 9.56569C79.1355 8.81461 78.8887 7.742 78.8887 6.52993C78.8887 5.31786 79.1355 4.24526 79.5111 3.49418C79.9017 2.71323 80.3489 2.42041 80.6942 2.42041C81.0396 2.42041 81.4867 2.71323 81.8773 3.49418C82.253 4.24526 82.4998 5.31786 82.4998 6.52993Z",
    stroke: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0355 13.1701C20.0015 10.9292 21.0425 8.80763 22.8356 7.46328L23.6942 6.81957C25.2738 5.63524 27.1991 5.0032 29.1733 5.02082L66.197 5.35127C68.0275 5.36761 69.6724 6.40926 70.7678 7.87593C72.0093 9.53822 73.3798 10.879 74.162 11.1397C75.3148 11.5238 78.0046 10.7556 78.0046 10.7556V107.152C78.0046 111.069 76.3073 114.793 73.3515 117.362C70.6698 119.693 67.1788 120.876 63.6325 120.654L31.6874 118.658C28.1969 118.44 25.0232 116.56 23.1553 113.603C22.0848 111.909 21.5024 109.952 21.472 107.949L20.0355 13.1701Z",
    fill: "#797880"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4172 13.4177C20.3844 11.2538 21.3543 9.19644 23.0445 7.8448L23.6289 7.37738C25.2461 6.0841 27.2597 5.38802 29.3304 5.4065L66.1965 5.73555C68.027 5.75189 69.701 6.76881 70.5764 8.37644C71.1951 9.51241 71.6208 10.2856 71.856 10.7557C72.2402 11.524 71.856 73.3684 71.856 73.3684V114.022C71.856 116.202 70.6978 118.218 68.8145 119.317C67.7901 119.914 66.6144 120.201 65.43 120.144L32.6463 118.553C29.4724 118.399 26.5082 116.922 24.4736 114.481C22.8098 112.486 21.8808 109.98 21.8414 107.382L20.4172 13.4177Z",
    fill: "#434449"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3501 22.0202C22.3156 17.5278 25.986 13.8878 30.4778 13.9596L62.4475 14.471C66.8153 14.5408 70.3195 18.1015 70.3195 22.4699V108.866C70.3195 113.54 66.3299 117.219 61.6715 116.84L30.351 114.295C26.2213 113.959 23.0312 110.526 22.9993 106.382L22.3501 22.0202Z",
    fill: "#2E2E36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3227 16.8332L29.9484 16.0848C29.611 15.4102 30.1134 14.6191 30.8674 14.6377L58.1959 15.3123C59.0432 15.3332 59.5095 16.3563 58.9922 17.0279C58.8421 17.2228 58.6949 17.4156 58.5562 17.5984C57.9753 18.3637 57.0791 18.818 56.1184 18.81C51.9928 18.7755 40.3983 18.6673 32.9183 18.4854C31.8137 18.4585 30.817 17.8214 30.3227 16.8332Z",
    fill: "#777777",
    stroke: "#282828"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3526 117.787L60.4364 117.976C60.7394 118.658 60.2169 119.419 59.4721 119.381L32.0556 117.993C31.395 117.96 30.9632 117.311 31.2282 116.705C31.2896 116.564 31.3528 116.423 31.4162 116.283C31.9171 115.176 33.0682 114.527 34.2802 114.612C39.1107 114.952 51.4602 115.794 57.617 115.973C58.8019 116.007 59.871 116.704 60.3526 117.787Z",
    fill: "#777777",
    stroke: "#282828"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5928 30.6906C24.5928 29.0208 25.9562 27.6723 27.6259 27.6908L60.8204 28.0578C62.4642 28.076 63.7872 29.4137 63.7872 31.0576V112.025C63.7872 113.763 62.3155 115.137 60.5819 115.018L27.3874 112.741C25.814 112.633 24.5928 111.325 24.5928 109.748V30.6906Z",
    fill: "#232227"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8984 36.1079H59.9447V58.7714L26.8984 58.3873V36.1079Z",
    fill: "#8C9FA3",
    stroke: "#1E1C21"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7227 72.024C50.7227 70.4329 52.0125 69.1431 53.6036 69.1431H55.1426C56.7337 69.1431 58.0236 70.4329 58.0236 72.024C58.0236 73.6151 56.7337 74.905 55.1426 74.905H53.6036C52.0125 74.905 50.7227 73.6151 50.7227 72.024Z",
    fill: "#2C2B30",
    stroke: "#4C4A4B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4355 71.2555C28.4355 69.6644 29.7254 68.3745 31.3165 68.3745H32.8555C34.4466 68.3745 35.7365 69.6644 35.7365 71.2555C35.7365 72.8466 34.4466 74.1364 32.8555 74.1364H31.3165C29.7254 74.1364 28.4355 72.8466 28.4355 71.2555Z",
    fill: "#2C2B30",
    stroke: "#4C4A4B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6572 79.8252C37.6572 78.1683 39.0004 76.8252 40.6572 76.8252H46.185C47.8419 76.8252 49.185 78.1683 49.185 79.8252V83.0442C49.185 84.7011 47.8419 86.0442 46.185 86.0442H40.6572C39.0004 86.0442 37.6572 84.7011 37.6572 83.0442V79.8252Z",
    fill: "#2C2B30",
    stroke: "#4C4A4B",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.7227,
    y: 30.73,
    width: 9.22222,
    height: 3.07302,
    rx: 1.53651,
    fill: "url(#paint1_linear_3707_108411)",
    stroke: "#1E1C21"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4355,
    y: 30.73,
    width: 3.07407,
    height: 3.07302,
    rx: 1.53651,
    fill: "url(#paint2_radial_3707_108411)",
    stroke: "#1E1C21"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3707_108411",
    x1: -5.9893e-8,
    y1: 5.76205,
    x2: 6.53239,
    y2: 6.14645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3707_108411",
    x1: 51.4912,
    y1: 31.8824,
    x2: 56.8708,
    y2: 32.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673F63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3707_108411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3568 31.8824) rotate(123.699) scale(1.38514 1.38532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44424D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26272C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathalyzer);
export default __webpack_public_path__ + "static/media/breathalyzer.a60ff0b53c50193ee14ee712e18aa36f.svg";
export { ForwardRef as ReactComponent };